module.exports = __webpack_public_path__ + "static/media/staticmedia.19456955.svg";